/**
 * Navigation Menu Component
 * Extracted from Header.js
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { SHOW_PRODUCTS_PAGE, SHOW_SERVICES_PAGE, SHOW_REFERRAL_SYSTEM } from '../../../config/featureFlags';
import { useTranslation } from '../../../context/LanguageContext';

const NavigationMenu = ({
  isWebsiteMenuOpen,
  setIsWebsiteMenuOpen,
  isServicesMenuOpen,
  setIsServicesMenuOpen,
  isMoreInfoMenuOpen,
  setIsMoreInfoMenuOpen,
  handleWebsiteMenuToggle,
  handleServicesMenuToggle,
  handleMoreInfoMenuToggle,
  handleWebsiteSubmenuClick,
  handleServicesSubmenuClick,
  handleMoreInfoSubmenuClick,
  handleLinkClick
}) => {
  const { t } = useTranslation();
  return (
    <nav className="nav">
      {/* Desktop Navigation Links */}
      <Link to="/" onClick={handleLinkClick} className="nav-link">
        {t('nav.home')}
      </Link>
      {SHOW_PRODUCTS_PAGE && (
        <Link to="/products" onClick={handleLinkClick} className="nav-link">
          {t('nav.products')}
        </Link>
      )}

      {/* Website Menu */}
      <div className="website-menu" onMouseLeave={() => setIsWebsiteMenuOpen(false)}>
        <Link
          to="/website"
          onClick={handleWebsiteMenuToggle}
          onMouseEnter={() => setIsWebsiteMenuOpen(true)}
          className="nav-link website-trigger"
        >
          {t('nav.website')}
          <svg className="chevron-icon" width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L3.5 3L6 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
        <div className={`website-dropdown ${isWebsiteMenuOpen ? 'show' : ''}`}>
          <button onClick={() => handleWebsiteSubmenuClick('/website')}>
            {t('nav.overview')}
          </button>
          <button onClick={() => handleWebsiteSubmenuClick('/website/essential')}>
            {t('nav.essential')}
          </button>
          <button onClick={() => handleWebsiteSubmenuClick('/website/professional')}>
            {t('nav.professional')}
          </button>
          <button onClick={() => handleWebsiteSubmenuClick('/website/business-plus')}>
            {t('nav.businessPlus')}
          </button>
          <button onClick={() => handleWebsiteSubmenuClick('/website/business-elite')}>
            {t('nav.businessElite')}
          </button>
          <button onClick={() => handleWebsiteSubmenuClick('/website/enterprise')}>
            {t('nav.enterprise')}
          </button>
        </div>
      </div>

      {/* Services Menu – hidden when SHOW_SERVICES_PAGE is false */}
      {SHOW_SERVICES_PAGE && (
        <div className="services-menu" onMouseLeave={() => setIsServicesMenuOpen(false)}>
          <Link
            to="/services"
            onClick={handleServicesMenuToggle}
            onMouseEnter={() => setIsServicesMenuOpen(true)}
            className="nav-link services-trigger"
          >
            {t('nav.services')}
            <svg className="chevron-icon" width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L3.5 3L6 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <div className={`services-dropdown ${isServicesMenuOpen ? 'show' : ''}`}>
            <button onClick={() => handleServicesSubmenuClick('/services/aiml')}>
              {t('nav.aimlServices')}
            </button>
            <button onClick={() => handleServicesSubmenuClick('/services/business')}>
              {t('nav.businessSolutions')}
            </button>
          </div>
        </div>
      )}

      {SHOW_REFERRAL_SYSTEM && (
        <Link to="/referral" onClick={handleLinkClick} className="nav-link">
          {t('nav.referral')}
        </Link>
      )}

      <Link to="/blogs" onClick={handleLinkClick} className="nav-link">
        {t('nav.blogs')}
      </Link>

      {/* More Info Menu */}
      <div className="more-info-menu" onMouseLeave={() => setIsMoreInfoMenuOpen(false)}>
        <Link
          to="#"
          onClick={handleMoreInfoMenuToggle}
          onMouseEnter={() => setIsMoreInfoMenuOpen(true)}
          className="nav-link more-info-trigger"
        >
          {t('nav.moreInfo')}
          <svg className="chevron-icon" width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L3.5 3L6 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
        <div className={`more-info-dropdown ${isMoreInfoMenuOpen ? 'show' : ''}`}>
          <button onClick={() => handleMoreInfoSubmenuClick('/careers')}>
            {t('nav.careers')}
          </button>
          <button onClick={() => handleMoreInfoSubmenuClick('/faq')}>
            {t('nav.faqs')}
          </button>
          <button onClick={() => handleMoreInfoSubmenuClick('/contact')}>
            {t('nav.contactUs')}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavigationMenu;
